var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 19,
    viewBox: "0 0 33 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9703 17.5861C32.9303 16.6262 32.9303 15.0696 31.9703 14.1096L19.9436 2.09462C18.0232 0.176132 14.9114 0.176893 12.992 2.09631L0.969899 14.1184C0.00987084 15.0784 0.00987084 16.635 0.969899 17.595C1.92995 18.5552 3.48647 18.5552 4.44652 17.595L14.7361 7.3054C15.6964 6.34542 17.2527 6.34542 18.2127 7.3054L28.4937 17.5861C29.4537 18.5461 31.0103 18.5461 31.9703 17.5861Z",
    fill: "#353A47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardUpArrow);
export default __webpack_public_path__ + "static/media/card-up-arrow.ac4238452743f1e3e80cd5d8fb7213af.svg";
export { ForwardRef as ReactComponent };